"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkForAnchors = void 0;
const checkForAnchors = button => {
  if (button?.anchor && button?.url != undefined) {
    return `${button?.url}#${button?.anchor}`;
  } else if (button?.anchor && button?.url === undefined || button?.url === null) {
    return `#${button?.anchor}`;
  } else {
    return button?.url;
  }
};
exports.checkForAnchors = checkForAnchors;